import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { Sheet } from './Sheet';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  body: string;
  confirmLabel: string;
  onConfirm: () => void;
  loading?: boolean;
  error?: string | undefined;
}

/** Explicit confirmation before a destructive action. */
export function ConfirmSheet({ open, onOpenChange, title, body, confirmLabel, onConfirm, loading, error }: Props) {
  const { t } = useTranslation();
  return (
    <Sheet open={open} onOpenChange={onOpenChange} title={title} description={body}>
      <div className="space-y-3">
        {error && <p role="alert" className="text-sm text-negative">{error}</p>}
        <Button variant="danger" block size="lg" loading={loading ?? false} onClick={onConfirm}>{confirmLabel}</Button>
        <Button variant="secondary" block onClick={() => onOpenChange(false)}>{t('common.cancel')}</Button>
      </div>
    </Sheet>
  );
}
